/** @format */
import Cookies from "js-cookie";

export default async function getDocs(instance, client, token) {
  const api_url = Cookies.get("ApiUrl");
  const apiUrl =`${api_url}/admin/document/list`;
  let bodyData = JSON.stringify({
    "InstanceId" : instance,
    "ClientId" : client 
})
  try {
    const response = await fetch(apiUrl, {
      method: "POST",
      headers: {
        "content-type": "application/json",
        Authorization: token,
      },
      body: bodyData
    });
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
    const data = await response.json();
    return data.message.list;
  } catch (error) {

    throw new Error(error);
  }
}
